<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :class="tableClass"
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top v-if="!isMinimal">
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template #[`item.bus_busena_buvusi`]="{ item }">
        <el-hipoteka-busena :busena="item.bus_busena_buvusi" />
      </template>
      <template #[`item.bus_busena_nauja`]="{ item }">
        <el-hipoteka-busena :busena="item.bus_busena_nauja" />
      </template>
      <template #[`item.bus_priezastis_aprasymas`]="{ item }">
        <template v-if="item.isGrazintas">
          <div class="nowrap">
            <span class="byla-title">Grąžinti dokumentai: </span>
            <el-byla
              v-for="byla in item.bylos"
              :key="byla.byl_id"
              :byla="byla"
              color="primary"
              in-line
              :class="byla.class"
            />
          </div>
        </template>
        <template v-if="item.isPagrindas">
          <span class="byla-title">Sprendimo motyvai: </span>
          {{ item.bus_priezastis_aprasymas }}<br />
          <span class="byla-title">
            Sprendimą pagrindžiančios procesinės ir materialinės teisės normos:
          </span>
          {{ item.bus_priezastis_pagrindas }}
        </template>
        <template v-if="!item.isPagrindas">
          <template v-if="item.isGrazintas">
            <span class="byla-title"
              >Grąžinimo tikslinti priežasties aprašymas: </span
            ><br />
          </template>
          <template v-if="item.isAtmestas">
            <span class="byla-title">Atmetimo aprašymas:</span><br />
          </template>
          {{ item.bus_priezastis_aprasymas }}
        </template>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'IstorijaBusena',
  props: {
    objId: Number,
  },
  data() {
    return {
      loading: true,
      search: null,
      istorija: [],
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['objektasID']),
    headers() {
      return [
        {
          text: 'Buvusi būsena',
          align: 'start',
          value: 'bus_busena_buvusi',
        },
        {
          text: 'Nauja būsena',
          align: 'start',
          value: 'bus_busena_nauja',
        },
        {
          text: 'Priežastis',
          align: 'start',
          value: 'bus_priezastis',
        },
        {
          text: 'Aprašymas',
          align: 'start',
          value: 'bus_priezastis_aprasymas',
        },
        {
          text: 'Būsenos data',
          align: 'start',
          value: 'bus_sukurimo_data',
        },
        {
          text: 'Naudotojas',
          align: 'start',
          value: 'bus_sukure',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.istorija.map(item => {
        item.isGrazintas =
          item.bus_busena_nauja === 'grazintas' &&
          item.bus_busena_buvusi !== 'grazintas'
        item.isAtmestas = item.bus_busena_nauja === 'atmestas'
        item.isPagrindas = !!item.bus_priezastis_pagrindas

        item.bylos = item.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `byla/${byla.byl_id}/${byla.byl_hash}/content`,
          }
        })
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isMinimal() {
      return this.objId > 0
    },
    comObjektasID() {
      return this.objId ?? this.objektasID
    },
    tableClass() {
      return this.isMinimal ? 'miniTable' : ''
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$axios
        .get(`objektas/${this.comObjektasID}/busenuistorija`)
        .then(res => {
          this.istorija = res.data.objektas
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.byla-title {
  font-weight: 600;
}
</style>
